import { Component, Input, OnInit } from '@angular/core';
import {colors, getColor} from "../colors";

@Component({
  selector: 'quick-stats',
  templateUrl: './quick-stats.component.html',
})
export class QuickStatsComponent implements OnInit {

  @Input() title: string = '';
  @Input() iconColor: string = '';
  @Input() icon: string = '';
  @Input() value: any = '';


  @Input() title2: string = '';
  @Input() value2: any = '';

  @Input() title3: string = '';
  @Input() value3: any = '';

  transparentColor = '';
  iconStyle = '';

  colors = colors;

  constructor() {}

  ngOnInit(): void {
    let iconColor = getColor(this.iconColor);
    this.transparentColor = iconColor + '20';
    this.iconStyle = `background-color: ${this.transparentColor}; color:${iconColor}`;
  }
}
